export default __webpack_public_path__ + "static/media/clinical-app-2.761675b6.jpg";